// Generated by scripts/build-ui-icons.mjs.
export { TreePalm as default } from "../ui/glyphs-7";
